import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "./common/table";
import auth from "../services/authService";

const $ = require("jquery");
$.DataTable = require("datatables.net");

class CardCodesTable extends Component {
  columns = [
    {
      path: "name",
      label: "Code Name",
    },
    {
      path: "code",
      label: "Code",
    },
    {
      path: "rate",
      label: "Rate",
    },
    {
      path: "completionTime",
      label: "Completion Time",
    },
    {
      key: (ccode) => `${ccode._id}-s`,
      label: "Info",
      content: (ccode) => (
        <Link
          to={`/card-codes/${ccode._id}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      ),
    },
  ];

  deleteColumn = {
    key: "delete",
    label: "Delete",
    content: (ccode) => (
      <button
        onClick={() => this.props.onDelete(ccode)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  editColumn = {
    key: "edit",
    label: "Edit",
    content: (ccode) => (
      <Link
        to={`/card-codes/edit/${ccode._id}`}
        className="btn btn-custom btn-sm"
      >
        Edit
      </Link>
    ),
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) {
      this.columns.push(this.editColumn);
      this.columns.push(this.deleteColumn);
    }
  }

  componentDidMount() {
    $(document).ready(function () {
      $("#dataTable").DataTable();
    });
  }

  render() {
    const { ccodes, message } = this.props;
    return <Table columns={this.columns} data={ccodes} message={message} />;
  }
}

export default CardCodesTable;
